import React from 'react';

const Button = ({ children, onClick, className = "", variant = "primary", icon: Icon, isDark }) => {
  // These are your standard sizes now baked into the base
  const baseStyles = "flex items-center justify-center gap-2 rounded-2xl font-black uppercase tracking-widest transition-all duration-300 active:scale-95 border text-[12px]";
  
  const variants = {
    // Matches the Lock icon style (White/Slate 600 or Slate 800/Slate 300)
    // Used for "Commit Changes", "Log New", and "Add New Service"
    primary: `px-6 py-3 shadow-sm ${isDark 
      ? "bg-slate-800 text-slate-300 border-slate-700 hover:bg-slate-700 hover:text-white" 
      : "bg-white text-slate-600 border-slate-200 hover:bg-slate-50 hover:text-black"}`,
    
    // Action variant for Square/Circle buttons (like the Back Arrow or Lock/Unlock toggle)
    action: `w-12 h-12 p-0 ${isDark
      ? "bg-slate-800 text-slate-300 border-slate-700 hover:bg-black hover:border-white"
      : "bg-white text-slate-600 border-slate-200 hover:bg-slate-100 shadow-sm"}`,

    ghost: "bg-transparent border-transparent text-current hover:bg-slate-100 px-6 py-3"
  };

  return (
    <button 
      onClick={onClick} 
      className={`${baseStyles} ${variants[variant]} ${className}`}
    >
      {Icon && <Icon size={16} />}
      {children}
    </button>
  );
};

export default Button;